<template lang="pug">
    .home.jiashao-home
      aside.aside
        .nav
          .system-name(@click="$router.push('/')") 嘉绍大桥
            span 除湿数据采集与监视控制系统
          .nav-bar
            .nav-buttom
              router-link(to="/jiashao/gasclamp") 全桥除湿数据
              router-link(to="/jiashao/towerStation") 塔柱除湿机组
              router-link(to="/jiashao/steelboxStation") 钢箱梁除湿机组
              router-link(to="/jiashao/rigidHingeStation") 刚性铰除湿机组
              router-link(to="/jiashao/errorRecord?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3") 报警记录
              router-link(to="/jiashao/currentHumidityList?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3&includePower=true") 湿度数据清单
              router-link(to="/jiashao/dataHistory?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3&scenarioId=TBD") 数据历史
      
      TimeBlock.time-block(bridgeName="ZHEJIANG", size="radar-size")
      RadarBlock.radar-block5(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListTower1"
        , :humidityPassLine="this.radarBlockHumidityLine", title="上塔柱", :initOnMount="this.radarBlockDelayInit", ref="radar5", @initComplete="initNextRadar('radar4')"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", @setRadarData="setRadarDataHandler")
      RadarBlock.radar-block4(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListTower2"
        , :humidityPassLine="this.radarBlockHumidityLine", title="中塔柱", :initOnMount="this.radarBlockDelayInit", ref="radar4", @initComplete="initNextRadar('radar3')"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", @setRadarData="setRadarDataHandler")
      RadarBlock.radar-block2(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListSteelbox1"
        , :humidityPassLine="this.radarBlockHumidityLine", title="绍向箱梁", ref="radar2", @initComplete="initNextRadar('radar1')"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", @setRadarData="setRadarDataHandler")
      RadarBlock.radar-block1(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListSteelbox2"
        , :humidityPassLine="this.radarBlockHumidityLine", title="嘉向箱梁", :initOnMount="this.radarBlockDelayInit", ref="radar1", @initComplete="initNextRadar('radar5')"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", @setRadarData="setRadarDataHandler")
      RadarBlock.radar-block3(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListRigidHinge"
        , :humidityPassLine="this.radarBlockHumidityLine", title="刚性铰", :initOnMount="this.radarBlockDelayInit", ref="radar3"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", @setRadarData="setRadarDataHandler")
      RadarBlock.radar-block6(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListFullBridge"
        , :humidityPassLine="this.radarBlockHumidityLine", title="全桥", ref="radar6", :inputDeviceIdPassRateDict="this.radarBlockFullResultDict"
        , splitLine="dark", :ignoreEmptyData="this.radarBlockIgnoreEmptyData", :allowUserSelectDevice="this.radarBlockAllowUserSelectDevice")
    </template>

<script>
import TimeBlock from "@/components/TimeBlock";

export default {
  name: "Index",
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",
      historyScenarioList: [],
      radarBlockDaysCount: 3,
      radarBlockHumidityLine: 50,
      radarBlockDelayInit: false,
      radarBlockAllowUserSelectDevice: true,
      radarBlockIgnoreEmptyData: true,
      radarBlockFullResultDict: {},
      radarBlockNameDeviceIdListTower1: {
        "Z3上塔T1": [
          "a8355f4b-f4f3-4175-bb43-48b6406edf37",
          "043033cb-8aec-4cd0-8ed6-077e21ecad87",
          "6d53aec4-a9f6-4575-bfa3-e94f9174c12c",
          "3c545c28-09e6-40d9-968b-75c8f92564ee"
        ],
        "Z4上塔T3": [
          "1a50053a-6642-4b2f-8485-448ad89d99d0",
          "8a9cebdb-1786-47f2-9f9e-86317cd06132",
          "87866948-3674-46ca-b70e-5e6a12d695e3",
          "eb14a35b-d46d-4d09-9ee4-f9b9f2880485"
        ],
        "Z5上塔T5": [
          "7c6e3109-18ff-4c72-8a86-1bf25ec57260",
          "72be3ac0-4b49-46d7-9d0b-cc4e384ccaee",
          "3f19ebed-f8a0-488a-b0ce-21bd639e4fe4",
          "95322bb5-d441-4efc-a306-0343885a9056"
        ],
        "Z6上塔T7": [
          "4404eb6b-a447-45cc-8739-9dd6d7b5c1c1",
          "3f7acdb7-dd95-454b-9e3a-e7f136fcba70",
          "950525c9-defe-49fc-a541-026f4b208ed3",
          "0f7a5716-23fc-4f23-862e-b705e9efd3ac"
        ],
        "Z7上塔T9": [
          "8635be2d-8dbb-4407-b101-3fc48e399a6c",
          "ebd0caf6-063a-4391-9a20-b177cf94ff31",
          "1d64c9bb-31a4-4d6c-9852-e5c67933eff9",
          "a4a44370-0b07-4afc-a73e-3ceb4167d43b"
        ],
        "Z8上塔T11": [
          "6a1c4917-87b6-46fa-8112-d81e787c680a",
          "42da9d50-2a83-4014-b9ed-011a1713426a",
          "f7633fec-d517-4abe-9f9d-04c41b748d87",
          "7794e86d-98aa-471d-b88c-4d9c945bad38"
        ],
      },
      radarBlockNameDeviceIdListTower2: {
        "Z3中塔T2": [
          "91ae8484-fa72-4536-bbcf-227485d00984",
          "d754da32-51b0-41fb-b5ca-e9a77c991508",
          "cf999266-3959-4cc2-a218-3a7e45b244ec",
          "4993762c-ce5b-44db-9373-959bbc19ac88"
        ],
        "Z4中塔T4": [
          "5d116a33-9429-4ea6-9c12-70ca1a3615c9",
          "21315ac6-9d0d-4b3c-9a11-3562c1e0254c",
          "e46e900c-00d4-4d4e-a1a4-dc0c2fe2be22",
          "7d62686f-b955-4542-a68f-4531b8e380a9"
        ],
        "Z5中塔T6": [
          "e63f2494-2009-431b-b169-d56c178fcc02",
          "8603c4f1-9d24-4f6f-99f7-c80977a28a9e",
          "3947a0d6-3873-449f-ae68-ccf7b9a353a9",
          "b56c3ba1-f85d-47c3-8900-ef99eb766838"
        ],
        "Z6中塔T8": [
          "7d85ad73-ed97-488f-a041-2a5a6a6be417",
          "95b75401-e353-4f3d-94ad-892e0bfca9d9",
          "a28e4ba8-e3dc-4262-9ccb-da8a80832708",
          "2372aa93-4e8a-4da0-a6a2-a770f1fbc99a"
        ],
        "Z7中塔T10": [
          "b1831c64-d258-498a-9323-4fba75f44760",
          "047a3dad-ca1c-48a7-9dc7-9ce32553aa97",
          "5d870b4f-bebf-448b-bce0-4b66c8f9df55",
          "340161df-96e4-4480-b352-ea7d9c036a7b"
        ],
        "Z8中塔T12": [
          "ad9ed67f-1dbf-4656-9fdd-e0f8ab65bd9f",
          "466fc2dd-b15d-44bf-98c5-295a4e9d26e8",
          "bd50b2df-4e9e-467a-b7b9-82886aadeb06",
          "e70eeeee-bd6c-4cee-b700-5ebacc7d3eb8"
        ],
      },
      radarBlockNameDeviceIdListSteelbox1: {
        "箱梁G1": [
          "4c9062f9-8757-41fb-9c7e-715157782742",
          "5dc7000b-cd2c-459a-9cf5-88cd8d11017b",
          "3605966d-1a70-402e-b3a8-8c880d6bfca2",
          "436b6e6c-9c01-4cff-b6d4-1c13d3e05175",
          "da6be5a7-f9f0-4ce3-9b44-83a4854aa1b7"
        ],
        "箱梁G3": [
          "a902c739-631a-49aa-926e-bcba1371c760",
          "fbef463a-2bbf-4eb6-be84-6e515249c71e",
          "52bb5182-60f9-44f2-9863-db862e969c22",
          "7586a52d-da9c-4904-920a-7e7fd3e1cb48",
          "f53739fc-4011-463b-9a07-f47bd7817586"
        ],
        "箱梁G5": [
          "0a8340f0-8905-4cee-88e7-590d6ef84f1a",
          "7c65f7c8-6e7a-47d9-97d5-6356a8cee0a1",
          "7b44ec39-64a7-41fa-bbb8-c847567eebc5",
          "5d01db45-b188-4244-951a-1199d8dab3f6",
          "9bb0c9f3-d2c9-41d6-aa5d-05608a6b82a9"
        ],
        "箱梁G7": [
          "55872f71-3d07-4804-be6a-c402bc3ac5c9",
          "e64d8a2c-466b-449f-8223-6a33c9b5a575",
          "6b45d5e5-b80f-4df1-98ff-c2f9ca718ac2",
          "6dc4690d-dae5-4c4d-9736-ae0654bed4c1",
          "a9cbb9f3-4542-4100-aa11-a828080b40db"
        ],
        "箱梁G9": [
          "d757bd03-388b-4cc9-ae60-76a3bd56cb92",
          "78f8396e-6d38-46e7-83da-3e3ecbd58ed8",
          "e311a943-28b9-4b96-bf94-31c803d754fd",
          "41dbce80-0dbb-494b-8af1-d15a4e5c18da",
          "150b79ac-f03a-4555-8c0b-3fa7d6f78f6e"
        ],
        "箱梁G11": [
          "58a62ade-9a2f-43d0-b241-4f43e8ebb11f",
          "ebaa11c1-41bb-433f-89c5-e8305b8d037c",
          "995f666c-4943-4341-b874-5f7e14d9953a",
          "1cb39d0d-5a4d-457b-a6f2-9a0b20c74563",
          "e6d8dd94-9585-469d-8c9a-653a2f46dcf3"
        ],
        "箱梁G13": [
          "adb119c3-d029-4bba-98b4-6f9bf3811a99",
          "021da40a-6448-4a76-9817-66dbdda69599",
          "787bba13-fc52-44ca-9af1-8c6ac492a67d",
          "b031623a-abf1-4987-b0a9-b5a3a268fdea",
          "6a879f04-e422-40a8-a66f-36fd82ebcd20"
        ],
        "箱梁G15": [
          "299c2fb6-419a-4ac6-adae-70b41e367243",
          "0bca3ad5-e290-4773-8389-4cdc4f75a362",
          "38cc55e1-1324-4262-ba21-26b599c93612",
          "6a1e3277-7b9c-4e5f-b12b-cd1dc4e8c2c0",
          "4cc57342-b48a-40dd-bc1c-2cb8889b0803"
        ],
      },
      radarBlockNameDeviceIdListSteelbox2: {
        "箱梁G2": [
          "9a43d9b9-97b8-48ed-97fa-41345ff6b1ea",
          "408bb3f4-819c-4a47-8fa4-c9abae496403",
          "e744b4c7-a28c-4d0c-a6b7-4432c5ed0c07",
          "f70cf50c-a9c0-4f81-bd92-c60a2e58eb86",
          "ef99103d-01e7-42e0-b4c8-e2f05b253f59"
        ],
        "箱梁G4": [
          "b8684cf4-fa64-426d-bdae-78162cdb8f85",
          "6bddf58c-0ba8-45c4-b5fc-a21264f4e609",
          "66fb152b-c0be-49d5-914f-61929d396ffa",
          "1ce2a3e5-ffcf-4334-80c7-29a6e38fc33c",
          "e511f1b7-7059-4ea6-b992-7253ba2b2a72"
        ],
        "箱梁G6": [
          "986fa3ee-ef35-4793-a76d-4503eb635dd3",
          "68fe2c60-fe05-4285-b37c-4fa174b925af",
          "bc5eda69-2f9e-4508-900b-f3ee35f9eba7",
          "5a2e28f3-939f-447b-bd05-40789b417ed1",
          "1dabce70-5c42-40b3-97c5-50861441e557"
        ],
        "箱梁G8": [
          "4779cc5d-da22-49be-9eb3-ead0c18fc5f1",
          "fa2435d7-64f1-490b-a760-d6c8b3eedf20",
          "667dc54f-939e-4483-8767-8ec2a1a73594",
          "e16fbbdf-8851-4aa6-97a1-13e950bb9e78",
          "1499ddef-148b-4907-97dc-a7a158f06a33"
        ],
        "箱梁G10": [
          "630109f2-286d-4543-b08a-4fc156d454d9",
          "c5dd12a3-991f-4b1d-aefd-f95cbd5aec54",
          "bd2e5432-bf65-4693-9280-0d77bce2c65c",
          "4ec1deee-eeac-4cb1-8b34-5dd3e203aee2",
          "5905ae20-31a1-49f9-b4ac-672d16391ca5"
        ],
        "箱梁G12": [
          "0149bb1b-eb51-42bb-b192-045454c601b4",
          "5a4d3b75-428b-4853-98bc-46c6bae175e3",
          "a6f2efd7-3a04-45e9-86a6-d42152e2894f",
          "30e51763-7795-4440-a5f3-eb0a56bc1b45",
          "8bdd38cd-7a70-496c-b90e-21b859a6d1f3"
        ],
        "箱梁G14": [
          "89634b5d-2248-404b-ba90-74ad920f5939",
          "79920847-5408-4d90-96ee-b81fc46a08b1",
          "122c0972-7f0a-43e1-b5cd-b3b4bd73b9d3",
          "a919955f-dfd3-4a21-98a5-b5a96db33017",
          "6ae4593e-8665-40ae-b873-9a2839aa422e"
        ],
        "箱梁G16": [
          "a0580166-531d-4d4a-b829-5d656f1dae11",
          "a1620726-95af-4f07-8fd4-c6196ccd90b1",
          "61d78ff5-30f1-4bb7-a008-5aeb3a602361",
          "c78a0045-c875-42e7-9fdf-db2e0c0016dd",
          "7fd56fd6-0c3e-43ae-97db-a9698dacbed2"
        ],
      },
      radarBlockNameDeviceIdListRigidHinge: {
        "刚性铰J1": [
          "0bfdc3a9-8759-4635-90db-bdda3a4cb320",
          "b4c2ddf6-ccf1-44d3-a9e0-24360f158693",
          "b0828718-8c03-4d16-a2b9-ce7f6895b0ad",
          "c72da272-6f4b-446d-8b8a-1199c8b7b411"
        ],
        "刚性铰J2": [
          "30eb13a7-4d05-4f96-8de2-62c62faa2a34",
          "d3409216-7aa8-42e8-a9e9-8e69c0275b49",
          "9f938b37-3566-4971-9a7f-71cc48260271",
          "375f25df-333f-4b80-bff5-9078df5c7c5b"
        ],
        "刚性铰J3": [
          "f8d73f17-5a52-464c-a870-139eaa852e52",
          "423413c9-3655-438d-aebd-f956d6c9708f",
          "1b7a48e6-9c4f-4841-9ed0-543b7b4b9004",
          "38b0c73c-06a5-4755-923d-139542350cc4"
        ],
        "刚性铰J4": [
          "d34cd6da-e0d6-49f6-9604-f02364d972ae",
          "5ae6b03a-7f17-425f-9846-2afbcecbac70",
          "0e8d4d7a-d536-407d-891f-6b54e5b25452",
          "6291142a-dc47-48f7-98e7-e7ce3ad75122"
        ]
      },
      radarBlockNameDeviceIdListFullBridge: {
        "绍兴向箱梁": [
          "箱梁G1",
          "箱梁G3",
          "箱梁G5",
          "箱梁G7",
          "箱梁G9",
          "箱梁G11",
          "箱梁G13",
          "箱梁G15",
        ],
        "嘉兴向箱梁": [
          "箱梁G2",
          "箱梁G4",
          "箱梁G6",
          "箱梁G8",
          "箱梁G10",
          "箱梁G12",
          "箱梁G14",
          "箱梁G16",
        ],
        "上塔柱": [
          "Z3上塔T1",
          "Z4上塔T3",
          "Z5上塔T5",
          "Z6上塔T7",
          "Z7上塔T9",
          "Z8上塔T11",
        ],
        "中塔柱": [
          "Z3中塔T2",
          "Z4中塔T4",
          "Z5中塔T6",
          "Z6中塔T8",
          "Z7中塔T10",
          "Z8中塔T12",
        ],
        "刚性铰": [
          "刚性铰J1",
          "刚性铰J2",
          "刚性铰J3",
          "刚性铰J4",
        ]
      }
    };
  },
  computed: {},
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    initNextRadar(refName) {
      let radar = this.$refs[refName];
      if (radar) {
        setTimeout(() => {
          radar.initChart();
        }, 1000);
      }
    },
    setRadarDataHandler(polygonNamePassRateDict) {
      for (let polygonName in polygonNamePassRateDict) {
        this.$set(this.radarBlockFullResultDict, polygonName, polygonNamePassRateDict[polygonName]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  min-height: 600px;
  position: relative;
  background: url("../../assets/image/jiashao/jiashao.jpg") center no-repeat;
  background-size: cover;

  &.jiashao-home {
    min-width: 1550px;
  }

  .time-block {
    position: absolute;
    top: 100px;
    right: 25px;
  }

  .radar-block1 {
    position: absolute;
    bottom: 75px;
    right: 775px;
  }

  .radar-block2 {
    position: absolute;
    bottom: 75px;
    right: 1025px;
  }

  .radar-block3 {
    position: absolute;
    bottom: 75px;
    right: 25px;
  }

  .radar-block4 {
    position: absolute;
    bottom: 75px;
    right: 275px;
  }

  .radar-block5 {
    position: absolute;
    bottom: 75px;
    right: 525px;
  }

  .radar-block6 {
    position: absolute;
    top: 100px;
    right: 275px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/jiashao/jiashao1.jpg") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;

        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>